import { CdoToAllDisMap } from '@onefootprint/core';
import type {
  CollectedDataOption,
  DataIdentifier,
  OnboardingRequirementCollectData,
} from '@onefootprint/request-types';
import { getAllAttributes } from './all-attributes';

const COLLECT_DATA_CDOS: CollectedDataOption[] = [
  'name',
  'dob',
  'nationality',
  'email',
  'phone_number',
  'full_address',
  'us_tax_id',
  'ssn9',
  'ssn4',
  'us_legal_status',
];

// The node genuinely requires contact info, so the requirement still reports it for API clients.
// But when identify already collected and verified it, prompting again would be unnecessary
const IDENTIFY_CDOS: CollectedDataOption[] = ['email', 'phone_number'];

export const getCollectDataAttributes = (requirement: OnboardingRequirementCollectData): CollectedDataOption[] => {
  const attributes = getAllAttributes(requirement);
  const skipped = requirement.ranIdentify ? IDENTIFY_CDOS : [];
  return COLLECT_DATA_CDOS.filter(cdo => attributes.includes(cdo) && !skipped.includes(cdo));
};

export const getCollectDataDis = (requirement: OnboardingRequirementCollectData): DataIdentifier[] =>
  getCollectDataAttributes(requirement).flatMap(cdo => CdoToAllDisMap[cdo] ?? []);
